import { ConfigOption } from '@ngx-formly/core';
import { FormlyPurchaseProposalProductLedgerComponent } from './components/formly-purchase-proposal-product-ledger/formly-purchase-proposal-product-ledger.component';

/** Formly types of the Bestelldispo (registered in `custom-formly.config.ts`). */
export const PURCHASE_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-purchase-proposal-product-ledger', component: FormlyPurchaseProposalProductLedgerComponent },
];
